import { type ReviewsViewContext } from "@src/appV2/redesign/ShiftDiscovery/useWorkplaceModalsDataContext";
import { type WorkplaceCommentType } from "@src/appV2/redesign/Workplace/Review/api/useWorkplaceComments";

import { type CommentReactionSource, type Reaction } from "../types";
import { CommentReactionButtons } from "./CommentReactionButtons";
import { WorkplaceReviewCommentRepliesAndLikesWrapper } from "./RepliesAndLikesWrapper";
import { WorkplaceReviewCommentRepliesCountIcon } from "./RepliesCountIcon";
import { WorkplaceReviewRemoveIcon } from "./WorkplaceReviewRemoveIcon";

interface ModalCommentEngagementActionsProps {
  workerReaction?: Reaction;
  totalLikes: number;
  totalDislikes: number;
  totalReplies: number;
  workplaceId: string;
  commentId: string;
  reactionSource: CommentReactionSource;
  viewContext: ReviewsViewContext;
  viewerIsAuthor: boolean;
  isExternalReview: boolean;
  onReactionChanged: (comment: WorkplaceCommentType) => void;
  onRemove: () => void;
}

export function ModalCommentEngagementActions(props: ModalCommentEngagementActionsProps) {
  return (
    <WorkplaceReviewCommentRepliesAndLikesWrapper>
      <WorkplaceReviewCommentRepliesCountIcon count={props.totalReplies} />
      <CommentReactionButtons
        workerReaction={props.workerReaction}
        totalLikes={props.totalLikes}
        totalDislikes={props.totalDislikes}
        workplaceId={props.workplaceId}
        commentId={props.commentId}
        source={props.reactionSource}
        viewContext={props.viewContext}
        onReactionChanged={props.onReactionChanged}
      />
      {props.viewerIsAuthor && !props.isExternalReview && (
        <WorkplaceReviewRemoveIcon onRemove={props.onRemove} />
      )}
    </WorkplaceReviewCommentRepliesAndLikesWrapper>
  );
}
